import React, { Component } from 'react';
import   SideNav from "./../../component/sidenav/sidenav.js"
import "./school.css"
import  AuthService  from "../api/authentication.js";
import  Notices  from "./school"
import  Show from "./show"
import  Moble from "./../../component/sidenav/moble.js"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    
    Redirect
  } from 'react-router-dom'


const Auth = new AuthService();
class School extends Component {
   constructor(props){
       super(props)
       this.state  = {
           loading : false,
           loadingnews  : false,
           noticeMassage : "",
           noticepop : false,
           news :[],
           noerorrpage :  true,
           sendTo : false,
           allPeople : false,
           closeAllbutton : true,
           loadData: true,
           message: [],
           ifRead : false,
           ifSumit : false,
           inboxs : [],
           ifInbox:true,
           unRead : false,
           school:null,
           studentModal:false,
           classes:[],
           students:[],
           user :[],
           localApi:'http://localhost:4000', 
           domain: 'https://exam-end.herokuapp.com', 
           getData:null,
           editData:null,
           setPick:null,
           selectUnit:"",
           DeleteData:null,
           classId:null
        
       }

   }


   componentWillReceiveProps(nextProps) {
		

    if (nextProps.organizer) {
   
     
      this.setState({
       
        organizer: nextProps.organizer,

     
      });
    
      
      this.getmessage(nextProps.organizer._id);
    }
  }



   componentWillMount(){
    // this.props.noerorrpage(this.state.noerorrpage)
    this.props.noerorrpage(this.state.noerorrpage)
        this.setState({
            noticepop : false,
            loadingnews :true,
            loanData:true
        })
        // console.log("get payment",  Auth.getProfile().userId)
   
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
        };
        fetch(this.state.domain+"/school/"+Auth.getProfile().id, requestOptions )
        .then(res => res.json())
        .then((res)=>{
            if(res){
                console.log()
                if(res.status === true){
                    console.log("data class", res)
                this.setState({
                    school : res.data,
                    students:res.data.students,
                    loanData : false
               
                })
              }else{
                this.setState({
                    loadingnews :false,
                  
                })
                 this.timeout()
              }
                // console.log("res notice",res, res.data)
               
            }else{
                this.setState({
                    lloadingnews  :true
                }) 
            }
        })
        fetch(this.state.domain+"/class/school/"+Auth.getProfile().id, requestOptions )
        .then(res => res.json())
        .then((res)=>{
       
            if(res){
              if(res.status === true){
                console.log("data class", res)
                this.setState({
                    loanData : false,
                    loadingnews :true,
                    classes:res.data,
                    classCount:res.data.length,
                    selectUnit:res.data[0]._id
                })
              }else{
                this.setState({
                    loadingnews :false,
                    loanData : true
                })
                 this.timeout()
              }
                // console.log("res notice",res, res.data)
               
            }else{
                this.setState({
                    loadingnews  :false
                }) 
            }
        })
    }
      


      getmessage=(data)=>{
     
      }
    
        checkUsers = ()=>{
            if(!this.props.user.fullname == "" && !this.props.user.address == ""  &&  !this.props.user.about == ""
            && !this.props.user.account_no == "" 
             && !this.props.user.phone_one =="" && !this.props.user.phone_two == "" ){
                 this.setState({
                   submitIftrue : true,
                 })
               return true
           }else{
               this.setState({
                   submitIftrue : false
                 })
               return  false
           }
          }
  

 
  
  
   onDelete=(data)=>{
    const requestOptions = {
        method: 'DELETE', 
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
        // body: JSON.stringify(dataedit),
      };
        // console.log("dalete", data)
        fetch(this.state.domain+"/notifications/"+ data, requestOptions)
        .then(res => res.json())
        .then((res)=>{
            if(res){
                // console.log("result", res)
                if(res.code !== 400){
                    this.setState({
                        loadingedit:true,
                        noticeshow : true,
                        noticeMassage : "Delete"
                    })
                    toast("Delete ");
                    this.timeout() 
                    const  news  = this.state.news
                    const fitlereddata =   news.filter( news =>{
                        return news._id !== data
                    })
                    // console.log(fitlereddata)
                    this.setState({news:fitlereddata,ifRead:false})
                }else{
                    toast("Failed to Delete !");
                }

            }
        }).catch( (error) => {
            //  console.log("errro", error);
            toast("Failed to Delete !");
            // console.log("error load", error )
        });
      
        this.setState({
            loading:false ,
           
            
        })  
    }




  

   timeout() {
    setTimeout(function() {
        this.setState({
            noticespop : false,
            // ifRead:true,
            loanData:false
        })
    //   console.log("data  loanData---===>", this.state.loadData);
    }.bind(this), 4000);
}

closeMessage=()=>{
    this.setState({
        ifRead:false,
    })
}
switchFormsendTo=()=>{
//    console.log("data yes")
   this.setState({
       sendTo :true,
       allPeople: false,
       closeAllbutton : false
   })
}
checkInbox=(e)=>{
   e.preventDefault()
   this.setState({
       ifInbox:true
   })
  
}
checkSend=(e)=>{
    e.preventDefault()
    this.setState({
        ifInbox:false
    })
   
 }
switchFormToevery=()=>{
    // console.log("data yes")
   this.setState({
       sendTo :false,
       allPeople: true,
       closeAllbutton :false
   })
}

switchFormAllclose=()=>{
    this.setState({
        sendTo :false,
        allPeople: false,
        closeAllbutton : true
    })
}

 get_random= (list)=> {
    return list[Math.floor((Math.random()*list.length))];
  }


  EditStudentInClass=(e)=>{
    e.preventDefault()
    console.log("data update===----->", )
    this.setState({
      loanData:true
    })
     const data = {
      lastname: this.lastName.value,
      firstname :this.firstName.value,
        getClass :this.state.selectUnit._id,
        school:this.state.school._id,
        gender:this.state.setPick,
        from:this.state.editData._id
     }
     console.log("data-------------->",data)
    const requestOptions = {
      method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
   
     fetch(this.state.domain+`/students/`+this.state.editData._id, requestOptions)
               .then(res => res.json())
               .then((res)=>{
                   if(res){
                      console.log("result-------->", res)
                      for (const obj of this.state.students) {
                        // console.log("data----------first----student>","id am getting==-->",this.state.editData._id,obj._id)
                        if (obj._id === this.state.editData._id) {
                          // console.log("data--------------student>","id am getting==-->",this.state.editData._id,obj._id)
                            obj.lastname = data.lastname;
                            obj.firstname = data.firstname;
                            obj.class = this.state.selectUnit;
                          break;
                        }
                      }
                      toast("Created !");
                       this.setState({
                           editShow:false,
                           loading:false,
                           loanData:false
                       })
                       
            
                   }
                 
               }).catch( (error) => {
                
          })
   }

   DeleteMethod=(data)=>{

    const requestOptions = {
      method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
     fetch(this.state.domain+`/students/`+this.state.DeleteData._id, requestOptions)
               .then(res => res.json())
               .then((res)=>{
                   if(res){
                      console.log("result-------->", res)
                      toast("Created !");
                       this.setState({
                           loading:false,
                           loanData:false
                       })
                       const  news  = this.state.students
                       const fitlereddata =   news.filter( news =>{
                           return news._id !== this.state.DeleteData._id
                       })
                       this.setState({
                         students:fitlereddata,
                         ifRead:false,
                        deleteModal:false
                        
                      })
                    
                   }
                 
               }).catch( (error) => {
                
          })
   }

   showDelete = (data) =>{
    this.setState({
      deleteModal:true,
      DeleteData:data,
    })
  
  }
  
   handleTerm = (e) => { 
    this.setState({
        setPick:e.target.value
    })  
 }

 closeModal = () =>{
  console.log("data-FALSE---student")
  this.setState({
      modal:false,
      studentModal:false,
      getData:null,
      deleteModal:false,
      editShow:false
  })
}

// addStudent=(da)=>{

// }

AddStudentInClass=(e)=>{
  e.preventDefault()
 
    this.setState({
      loanData:true
    })
     const data = {
        firstName: this.lastName.value,
        lastName :this.firstName.value,
        getClass :this.state.selectUnit,
        schoolId:this.state.school._id,
        gender:this.state.setPick,
     }
     console.log("data-----------add STUDENT --->",data)
     const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
     fetch(this.state.domain+`/students`, requestOptions)
               .then(res => res.json())
               .then((res)=>{
                   if(res){
                      console.log("result-------->", res)

                    const students =   this.state.students
                           students.push(res.data)
                      toast("Created !");
                       this.setState({
                            students:students,
                           loading:false,
                           loanData:false,
                           modal:false
                       })
                       
                      //  this.props.history.replace('/dashboard');
                   }
                 
               }).catch( (error) => {
                
          })
}

  
  EditShow=(data)=>{
    console.log("data----------------shool>",data)
    this.setState({
      editData:data,
      getData:data,
      setPick:data.gender,
      editShow:true,
      selectUnit:data.class
    })
 
  }

  Unitselect = (e) =>{
    console.log("data--===------> selectcurrency", e.target.value)
    this.setState({
      // ifCatalog:true,
      classId: e.target.value,
      // editShow:false
  })
  }

  addStudent=()=>{
    this.setState({
      modal:true
    })

  }
    
  render() {

    // console.log("data message-->", this.state.news, this.props.user)
    return (
        
        //  !this.props.isAuthenticated ?
                
        //     <Redirect to={{    pathname: `${'/dashboard'}`  }}/>
    
        //   :
        !this.props.isAuthenticated ? (
            <div className="hero is-bold is-fullheight">
            <div className="level-item">
              <a className="button is-loading is-large is-light">Loading</a>
            </div>
            <div className="level-item">
              <span>Trying to login...</span>
            </div>
          </div>
            ) : 
            <div id="dashboard-wrapper " class="columns dashboard-cousom">
                 <ToastContainer />

                 <div className="show-page">
                 {
                    this.state.school === null?
                     <div> </div>
                     :
                     <div>
                         <div className="show-info-school">
                           <div>
                               <h2><b>Name :</b> {this.state.school.name}</h2>
                               <h2><b>Address :</b> {this.state.school.address}</h2>
                               <h2><b>Phone :</b> {this.state.school.phoneNumber}</h2>
                           
                               
                               {/* <h2><b> :</b> school name</h2> */}
                           </div>
                         </div>
                         <div className='addStudentBotton'>
                           <a className='button   is-rounded' onClick={this.addStudent}> Add Student</a>
                         </div>
                         <div className="show-details">
                           <div className="show-details-list">
                             <div className="show-name">
                               <b>Fullname</b>
                             </div>
                             <div className="show-school">
                               <b>Sex</b>
                             </div>
                             <div className="show-class"> 
                               <b>Class </b>
                             </div>
                             <div className="show-code">
                               <b>Status</b>
                             </div>
                           </div>
                           {
                            this.state.students.map(item => (
                               <div className="show-details-lists" className={`show-details-lists ${this.get_random(["show-random2","show-random1","show-random3"])}`}>
                                 <div className="show-name" >
                                 {item.firstname +" " + item.lastname}
                                 </div>
                                 <div className="show-school">
                                 {item.gender}
                                 </div>
                                <div className="show-code">
                                {item.class.name}
                                </div>
                                 <div className="show-code " >
                                     <div className='class-bottom' style={{display:'flex'}}>
                                        <a class="button is-small btn-align accent-btn raised rounded btn-outlined" 
                                        style={{marginLeft:'4%'}}  onClick={(e)=>this.EditShow(item)}
                                        >Edit</a>
                                        <a  style={{marginLeft:'10%'}}  class="button is-small is-danger is-rounded" 
                                        onClick={(e)=>this.showDelete(item)}
                                        >delete</a>
                                 </div>
                                 </div>
                               </div>
                             ))
                           }
                           
                         </div>
   
                     </div>
                 }
                
               </div>

             {/* <!-- /Add  Student  --> */}
               {
                this.state.modal?
                <div class="pre-loader">
                 <div className="modal is-active add-student-cost">
                     <div className="modal-background" ></div>
                  <div className="modal-card">
                     <header className="modal-card-head">
                    
                      <p className="modal-card-title" style={{textTransform:'capitalize'}}>Add Student </p>
                     
                   
                     <button className="delete" aria-label="close" onClick={this.closeModal}></button>
                     </header>
                     <section className="modal-card-body">
                     <form onSubmit={this.AddStudentInClass}>
                      <div class="columns">
     
                       <div class="column is-one-third">Name :</div>
                         <div class="column">
                             <div class="control">
                                 <input class="input is-small" type="text" 
                                    ref={ input => this.firstName = input }
                                     placeholder="First name"/>
                                 </div>
                             </div>
                             <div class="column">
                                <div class="control">
                                     <input class="input is-small" type="text" 
                                         ref={ input => this.lastName = input }
                                         placeholder="Last name" required
                                      />
                                 </div>
                             </div>
                        </div>
                        
                        <div class="columns">
                          <div class="column is-one-third">Sex:</div>
                           <div class="column">
                             <div class="field">
                              <div class="control">
                                <div class="select ">
                                 <select onChange={this.handleTerm}  class="form-control" value={this.state.pick} >
                                         <option > Sex </option>
                                         <option value={"Male"}>Male</option>
                                         <option value={"Female"}>Female</option>
                                    </select>
                                 </div>
                                 </div>
                               </div>
                            </div>
                            <div class="column ">Class:</div>
                              <div class="column">
                                    <div class="select ">
                                      <select class="form-control" style={{width:"200px"}} onChange={this.Unitselect} value={this.state.selectUnit}>
                                      {
                                        this.state.editData === null ||  this.state.editData === undefined ?
                                        null
                                        :
                                        <option value={this.state.selectUnit._id}>  {this.state.selectUnit.name}    </option> 
                                        
                                      }
                                        
                                        {
                                          this.state.classes.map(data => {
                                                return  <option key={data} value={data._id}>{data.name}</option>
                                            })
                                        }
                                      </select>
                                    </div>
                                </div>
                            </div>
                            <div className="info-payment-button">
                            {
                                this.state.loanData?
                                  <a class="button is-loading">Loading</a>
                                :
                                <button  class="button is-primary is-rounded" >Submit</button>
                            }
                                
                            </div>
                      </form>  
                     </section>
                     
                     </div>
                 </div>
                 </div>
                 :
                 <div></div>
            }

            
            {
              this.state.editShow?
              <div class="pre-loader">
                <div className="modal is-active add-student-cost">
                <div className="modal-background" onClick={this.closeModal}></div>
                    <div className="modal-card">
                      <header className="modal-card-head">
                      {
                        this.state.editData === null || this.state.editData === undefined ?
                        <p className="modal-card-title">tile</p>
                        :
                        // eslint-disable-next-line no-sequences
                        <p className="modal-card-title">Edit {this.state.editData.firstname} {" "}  {this.state.editData.lastname} </p>
                      }
                   
                      <button className="delete" aria-label="close" onClick={this.closeModal}></button>
                      </header>
                      <section className="modal-card-body">
                      <form onSubmit={this.EditStudentInClass}>
                      <div class="columns">
                     
                      <div class="column is-one-third">Name :</div>
                        <div class="column">
                            <div class="control">
                                <input class="input is-small" type="text" 
                                    ref={ input => this.firstName = input }
                                    defaultValue={this.state.editData.firstname} 
                                    placeholder="First name"/>
                                </div>
                            </div>
                            <div class="column">
                                <div class="control">
                                    <input class="input is-small" type="text" 
                                        ref={ input => this.lastName = input }
                                        defaultValue={this.state.editData.lastname} 
                                        placeholder="Last name" required 
                                      />
                                </div>
                            </div>
                        </div>
                      
                        <div class="columns">
                          <div class="column ">Gender:</div>
                          <div class="column">
                            <div class="field">
                              <div class="control">
                                <div class="select ">
                                <select onChange={this.handleTerm}  class="form-control" value={this.state.setPick} >
                                      {
                                        this.state.editData === null ||  this.state.editData === undefined ?
                                        null
                                        :
                                        <option value={this.state.editData.gender}>  {this.state.editData.gender}    </option> 
                                        
                                      }
                                     
                                        <option value={"Male"}>Male</option>
                                        <option value={"Female"}>Female</option>
                                    </select>
                                </div>
                                </div>
                              </div>
                            </div>
                            <div class="column ">Class:</div>
                            <div class="column">
                              
                               
                                  <div class="select ">
                                    <select class="form-control" style={{width:"200px"}} onChange={this.Unitselect} value={this.state.selectUnit}>
                                    {
                                      this.state.editData === null ||  this.state.editData === undefined ?
                                      null
                                      :
                                      <option value={this.state.selectUnit._id}>  {this.state.selectUnit.name}    </option> 
                                      
                                    }
                                      
                                      {
                                        this.state.classes.map(data => {
                                              return  <option key={data._id} value={data._id}>{data.name}</option>
                                          })
                                      }
                                    </select>
                                  </div>
                           
                              
                              </div>
                           
                        </div>

                        
                        <div className="info-payment-button">
                        {
                            this.state.loanData?
                              <a class="button is-loading">Loading</a>
                            :
                            <button  class="button is-primary is-rounded" >Submit</button>
                        }
                            
                        </div>
                      </form> 
                      </section>
                     
                    </div>
                    </div>
                </div>
                :
                <div></div>
   
            }
            
            {
              this.state.deleteModal?
              <div class="pre-loader">
              <div className="modal is-active add-student-cost ">
                <div className="modal-background" onClick={this.closeModal}></div>
                <div className="modal-card">
                  <header className="modal-card-head">
                  {
                    this.state.DeleteData === null ||  this.state.DeleteData  === undefined ?
                    <p className="modal-card-title">tile</p>
                    :
                    <p className="modal-card-title">Delete  </p>
                  }
                  
                  <button className="delete" aria-label="close" onClick={this.closeModal}></button>
                  </header>
                  <section className="modal-card-body" style={{textAlign: 'center'}}>
                    {
                      this.state.DeleteData === null ||  this.state.DeleteData  === undefined ?
                      <p className="modal-card-title">Delete</p>
                      :
                      <p className="modal-card-title">Are You Sure want To delete<br/> 
                      { this.state.DeleteData.firstname}  {'  '}   { this.state.DeleteData.lastname}</p>
                    }
                    
                    {
                      this.state.loanData?
                        <a class="button is-loading" style={{marginTop:'30px'}}>Loading</a>
                      :
                      <a  style={{marginLeft:'10%',marginTop:'30px'}}  class="button  is-danger is-rounded" 
                      onClick={(e)=>this.DeleteMethod()}
                      >Delele</a>
                    }
                  
                  </section>
                 
                </div>
              </div>
              </div>
              :
              <div></div>
            }
                
          
             {/*
            <div className="modal is-active">
                <div className="modal-background" onClick={this.state.closeModal}></div>
                <div className="modal-card">
                  <header className="modal-card-head">
                  <p className="modal-card-title">tile</p>
                  <button className="delete" aria-label="close" onClick={this.state.closeModal}></button>
                  </header>
                  <section className="modal-card-body">
                   jsghdjksld
                  </section>
                  <footer className="modal-card-foot">
                  <button className="button is-success">Save changes</button>
                  <button className="button" onClick={this.state.closeModal}>Cancel</button>
                  </footer>
                </div>
              </div>
     
               
         
            */}
     
               
            </div>






            
        
        

    )

}





}

export default School ;


// WEBPACK FOOTER //
// ./src/component/school/school.js